var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2Switch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.39 33.21L40 47.41V69h-4V49.1l-13.39-13 2.78-2.89zM36 7v24h4V7h-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Switch.c08b3080.svg";
export { SvgA2Switch as ReactComponent };